import Axios from 'axios';
import { YouInvest } from 'src/Api';

const apiv2Routes = [ // Used to determine if we need access-token refreshes
    '/api/v2/watchlists'
];

const getRefreshAccessTokenPromise = () => {
    return Axios({
        method: 'POST',
        url: '/api/user/wso2-refresh',
        headers: YouInvest.getTradingRequestHeaders()
    });
}

export default function refreshTokenInterceptor(settings) {
    const interceptor = () => {
        if (!settings.guest) {
            return Axios.interceptors.response.use(function (response) {
                return response;
            }, async function (error) {
                if(error?.response?.status === 403) {
                    const originalRequest = error.config;

                    const apiv2RoutesMatched = apiv2Routes.filter((route) => {
                        return error.response.config.url.startsWith(route);
                    });

                    if (apiv2RoutesMatched.length) {
                        if (!originalRequest._retry) {
                            originalRequest._retry = true;
                            await getRefreshAccessTokenPromise(); // This updates the accessToken cookie
                            return Axios(originalRequest); // Retry the original request
                        }
                    }
                }
                return Promise.reject(error);
            })
        }

        return null;
    }

    return interceptor();
}